module.exports = __webpack_public_path__ + "static/media/iconToggle.88a81c9e.svg";